const user_centralCN = {
    USER_CENTRAL_01:'My Companies And Contacts',
    USER_CENTRAL_02:'My Companies',
    USER_CENTRAL_03:'My Contacts',
    USER_CENTRAL_04:'Contains ',
    USER_CENTRAL_05:'Result,',
    USER_CENTRAL_06:'Contacts Selected',
    USER_CENTRAL_10:'Contact Information',
    USER_CENTRAL_13:'Role',
    USER_CENTRAL_13_U:'Job Function',
    USER_CENTRAL_14:'Level',
    USER_CENTRAL_14_U:'Job Level',
    USER_CENTRAL_15:'Email',
    USER_CENTRAL_16:'Company Infomation',
    USER_CENTRAL_21:'Revenue',
    USER_CENTRAL_24:'Headquarters',
    USER_CENTRAL_25:'Product&Service',
    USER_CENTRAL_26:'Description',
    USER_CENTRAL_27:'Keyword',
    USER_CENTRAL_28:'No Data',
    USER_CENTRAL_29:'Companies Selected',
}
export default user_centralCN


// WEBPACK FOOTER //
// ./src/lan/en/en_user_central.js